export default __webpack_public_path__ + "static/media/doc-refresh-ico.e0241079.svg";